export enum DocType {
    Content = "content",
    Group = "group",
    Language = "language",
    Redirect = "redirect",
    Post = "post",
    Tag = "tag",
    User = "user",
    DeleteCmd = "deleteCmd",
    Storage = "storage",
    Crypto = "crypto",
    AuthProvider = "authProvider",
    AutoGroupMappings = "autoGroupMappings",
    // CMS-editable global baseline affinity profile (singleton). Delivered at
    // login to seed a client-local recommendation profile (cold start).
    DefaultAffinity = "defaultAffinity",
    // Server-only payload; mirrored here only so Record<DocType> fixtures type-check.
    Sidecar = "sidecar",
}

/**
 * Discriminator for the SidecarDto `data` payload shape (mirrored from the API).
 */
export enum SidecarType {
    HlsEncryptionKey = "hlsEncryptionKey",
}

export enum PublishStatus {
    Draft = "draft",
    Published = "published",
}

export enum TagType {
    AudioPlaylist = "audioPlaylist",
    Category = "category",
    Topic = "topic",
}

export enum PostType {
    Blog = "blog",
    Page = "page",
}

export enum RedirectType {
    Permanent = "permanent",
    Temporary = "temporary",
}

export enum DeleteReason {
    Deleted = "deleted",
    PermissionChange = "permissionChange",
    StatusChange = "statusChange",
    /**
     * A content slug was renamed with no redirect replacing the old slug. The SSG
     * deletes the old slug's static file; clients ignore it (the content is live).
     */
    SlugChange = "slugChange",
}

export enum StorageType {
    Image = "image",
    Media = "media",
}

export enum StorageStatus {
    Connected = "connected",
    Unreachable = "unreachable",
    Unauthorized = "unauthorized",
    NotFound = "not-found",
    NoCredential = "no-credentials",
    Checking = "checking",
    Unknown = "unknown",
}

export enum AckStatus {
    Accepted = "accepted",
    Rejected = "rejected",
}

export enum AclPermission {
    View = "view",
    Edit = "edit",
    Delete = "delete",
    Assign = "assign",
    Translate = "translate",
    Publish = "publish",
    // Sharing of published content from the app (share sheet / social links).
    Share = "share",
    // Access to view documents in the CMS, including drafts and expired content.
    // Gates all CMS-scoped (cms:true) reads/sync; the app uses plain View (published only).
    CmsView = "cmsView",
}
